export const CUTSCENE_SCRIPT = [
  /*
  // Basic character showcase with gradient background
  {
    type: 'showcase',
    foregroundCharacter: {
      character: 'hero',                    // Character identifier
      variation: 'neutral',                 // Character's emotional state/pose
      startPosition: { x: 1.2, y: 200 },    // Start off-screen right
      endPosition: { x: -0.2, y: 200 },     // Move to left side
      scale: 2.5,                          // Character size multiplier
      initialAnimationDuration: 1,         // How long the movement takes
      continuation: {
        distance: 0,                       // Additional movement after initial
        duration: 0                        // Time for additional movement
      }
    },
    backgroundGradient: {
      startColor: '#4834d4',               // Top color of gradient
      endColor: '#686de0'                  // Bottom color of gradient
    },
    motionLines: {
      rotation: -15,                       // Angle of motion lines
      duration: 1                          // How long motion lines are visible
    },
    sceneDuration: 1,                      // Total scene length
    fadeDuration: 0.3,                     // Transition fade time
    fadeOpacity: 0.5,                      // Maximum fade darkness
    transitionType: 'bloom'                // Special effect for transition
  },

  // Scene with background image and animation
  {
    type: 'showcase',
    background: 'castle',                  // Background image identifier
    backgroundAnimation: {
      startPosition: { x: 0, y: 0 },       // Starting position of background
      endPosition: { x: -200, y: 0 },      // Ending position (panning left)
      zoom: 1.2                            // Optional zoom effect
    },
    svg: 'assets/logo.svg',                // Overlay SVG image
    sceneDuration: 6,
    fadeDuration: 1.2,
    fadeOpacity: 0.5,
    transitionType: 'bloom'
  },

  // Scene with foreground and background characters
  {
    type: 'showcase',
    foregroundCharacter: {
      character: 'hero',
      variation: 'neutral',
      startPosition: { x: 0.8, y: 300 },
      endPosition: { x: -0.3, y: 300 },
      scale: 2.0,
      initialAnimationDuration: 0.4,
      continuation: {
        distance: -0.1,                    // Continue moving left
        duration: 1.6                      // Over this duration
      }
    },
    backgroundCharacter: {                 // Character in background
      character: 'companion',
      variation: 'surprised',
      startPosition: { x: -0.8, y: -50 },
      endPosition: { x: 0.3, y: -50 },
      scale: 0.8,                          // Smaller scale for background
      initialAnimationDuration: 0.4,
      continuation: {
        distance: 0.05,                    // Slight movement right
        duration: 1.6
      }
    },
    background: 'throne_room',
    backgroundAnimation: {
      startPosition: { x: 0, y: 0 },
      endPosition: { x: -100, y: 0 }
    },
    sceneDuration: 2,
    fadeDuration: 0.3,
    fadeOpacity: 0.5,
    transitionType: 'darken'
  },
        {
        character: 'riku',
        variation: 'neutral',
        zPosition: 0.9,
        startX: 1.2,
      },
      {
        character: 'hana',
        variation: 'thinking',
        zPosition: 0.6,
        startX: 0.2,
      },
      {
        character: 'principal',
        variation: 'surprised',
        zPosition: 0.5,
        startX: 1.5,
      },
      {
        character: 'sakura',
        variation: 'surprised',
        zPosition: 0.3,
        startX: 0.8,
      },
      {
        character: 'tanaka',
        variation: 'neutral',
        zPosition: 0,
        startX: 0.5,
      }

  // Ensemble scene with multiple characters
  {
    type: 'ensemble',                      // Special type for group scenes
    characters: [
      {
        character: 'hero',
        variation: 'neutral',
        zPosition: 0.9,                    // Depth positioning (0-1). This is the closest to the viewer
        startX: 1.2,                       // Starting X position. Make sure to vary the startX position for images at different depth positions. This way, as we parallax, we have a more interest animation. Here are some example zPosition startX pairs. 0.9, 1.2; 0.6, 0.2; 0.5, 1.5; 0.3, 0.8; 0.0, 0.5; If you use these z positions, use the same pair
      },
      {
        character: 'companion',
        variation: 'thinking',
        zPosition: 0.6,
        startX: 0.2,
      },
      {
        character: 'villain',
        variation: 'surprised',
        zPosition: 0.3,
        startX: 0.8,
      }
    ],
    backgroundGradient: {
      startColor: '#4a90e2',
      endColor: '#87ceeb'
    },
    backgroundParallax: {                  // Moving background effect
      startX: 0,
      endX: -100
    },
    characterMovement: {
      distance: -600                       // All characters move this distance. Always use this distance
    },
    motionLines: {
      rotation: 0,
      duration: 3.0
    },
    sceneDuration: 3.0,
    fadeDuration: 0.3,
    fadeOpacity: 0.5,
    transitionType: 'bloom'
  }
   */
];